import React from 'react';
import Grid from '@bexs/dollar/components/Grid';
import Card from '@bexs/dollar/components/Card';

import Title from './Title';
import Form from './Form';

const Download: React.FC = () => {
  return (
    <Card style={{ marginTop: '24px' }}>
      <Grid columns="1fr 2fr 1px" gap="80px">
        <Title />
        <Form />
      </Grid>
    </Card>
  );
};

export default Download;
